import * as types from '../actions/actionTypes.js';
import {getMessage} from "./i18n";

export default (state, action) => {

    switch ( action.type ) {

        case types.SHOW_SNACKBAR:
            let queue;
            queue = state.queue.slice();
            queue.push({ id: action.id, messageId: action.messageId, label: action.label, autohide: action.autohide, action: action.action });
            return Object.assign( {}, {queue: queue} );

        case types.DISMISS_SNACKBAR:
            queue = state.queue.filter((snack) => {
                return snack.id !== action.id;
            });
            return Object.assign( {}, {queue: queue} );

        default:
            return state;
    }
};

export const getSnack = (state) => state.stolo.ui.snackbar.queue[0] || null;

/**
 * Returns a snack thats label is populated by i18n message determined by provided
 * messageId.
 *
 * @param state
 * @returns {*}
 */
export const getPopulatedSnack = (state) => {
    const snack = state.stolo.ui.snackbar.queue[0] || {};
    if(snack.id) {
        const message = getMessage(state, snack.messageId);
        return Object.assign({}, snack, { label: snack.label ? snack.label : message });
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/reducers/ui.snackbar.js